import { render } from "./App.vue?vue&type=template&id=e8921cb8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e8921cb8&scoped=true&lang=scss"

import exportComponent from "E:\\Work\\bigSis_vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8921cb8"]])

export default __exports__